

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.DYsERRJ4.js","_app/immutable/chunks/D0KpzAQe.js","_app/immutable/chunks/CKFcjP6K.js","_app/immutable/chunks/DeAdfmry.js","_app/immutable/chunks/_z0kEE30.js","_app/immutable/chunks/Af96Cbic.js","_app/immutable/chunks/DidpMcX_.js","_app/immutable/chunks/BREGS9Lr.js"];
export const stylesheets = [];
export const fonts = [];
